import Vue from 'vue'

Vue.filter('numbercomma', function (num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
})
